import React from "react";

import { Intent } from "@blueprintjs/core";
import { ID } from "common/entities/IEntity";
import Loading from "common/fragments/Loading";
import NonIdealState from "common/fragments/NonIdealState";
import { BlockView } from "common/views/block/BlockView.view";
import { ButtonVariant, ButtonView } from "common/views/button/Button.view";
import HeadingView, { HeadingVariant } from "common/views/heading/Heading.view";
import { Query } from "core/api/typedQuery";
import { IPanelProps, Panel } from "core/decorators/Panel";
import AppToaster from "core/util/AppToaster";
import { iDef, nDef } from "core/util/TypeUtils";
import { MessageEditForm } from "./component/MessageEditForm";
import { Message } from "./entities/Message";
import { MessageEditConfig } from "./MessageEditConfig";
import { OrgQuery } from "./MessageList.panel";
import labelProvider from './MessageEdit.labels';
interface IMessageQueryProps {
	id: ID;
	targetGroupIds: ID[]; // send current org group id
}
const { Labels } = labelProvider;
let MessageQuery = Query.queryOne<Message, IMessageQueryProps>(Message);

const PARAM_GUID = "guid";
export const PARAM_SELECTED_MESSAGE = "org.messageId";

@Panel({id: "organization-message-edit", configClass: MessageEditConfig, pageParams: true,labelProvider})
export class MessageEditPanel extends React.Component<IPanelProps<MessageEditConfig>,{messageId:any}> {
	public render() {
		const { pageParams } = this.props;
		 
		const guid = pageParams[PARAM_GUID];
		
		if (nDef(guid)) {
			return (
				<NonIdealState
					title={<Labels.OrganizationEmpty />}
					description={<Labels.DescriptionEmpty />}
				/>
			);
		}

		return (
			
			<OrgQuery params={{guid}}>
				{(orgArgs) => {
					if (orgArgs.loading) {
							return <Loading />;
						}

					if (!orgArgs.data || !orgArgs.data.group) {
						return (
							<NonIdealState
								title={<Labels.OrganizationNotFound />}
								description={<Labels.OrganizationNotfoundDescription/>}
							/>
						);
					}

					let sMessageId = pageParams[PARAM_SELECTED_MESSAGE];
					
					if (iDef(sMessageId)) {
						MessageQuery = Query.queryOne<Message, IMessageQueryProps>(Message);
						return (
							<MessageQuery key='query' params={{
								id: sMessageId,
								targetGroupIds: [orgArgs.data.group.id]
							}} autoLoad={true}>
								{(msgArgs) => {
									if (msgArgs.loading) {
										return (
											<Loading />
										);
									}

									return (
										<React.Fragment>
											<ButtonView onClick={() => this.props.actions.removePageParam(PARAM_SELECTED_MESSAGE)} viewKey="back">
												Create New
											</ButtonView>
											{this.renderMessageForm(orgArgs.data.group.id, msgArgs.data)}
										</React.Fragment>
									);
								}}
							</MessageQuery>
						);
					}

					return this.renderMessageForm(orgArgs.data.group.id);
				}}
			</OrgQuery>
		);
	}

	private renderMessageForm = (groupId: ID, message?: Message) => {
		return (
			<React.Fragment>
				<BlockView viewKey="header">
					<HeadingView
						children={message ? "Edit Announcement" : "Create Announcement"}
						variant={HeadingVariant.H2}
						viewKey="header-text"
					/>
				</BlockView>
				<MessageEditForm
					data={message}
					groupId={groupId}
					onCreated={this.onCreated}
					onUpdated={this.onUpdated}
					key={Math.random()}
				/>
			</React.Fragment>
		);
	}

	private onCreated = (message: Message) => {
		// console.log(message)
		// return message;
		AppToaster.show({
			message: "Successfully Created",
			intent: Intent.SUCCESS
		});
	}

	private onUpdated = (message: Message) => {
		AppToaster.show({
			message: "Successfully Updated: " + (message.name || "Untitled"),
			intent: Intent.SUCCESS
		});
		this.props.actions.removePageParam(PARAM_SELECTED_MESSAGE)
	}
}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/MessageEdit.panel.tsx